import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxMaskModule } from 'ngx-mask';
import { CommonWordingModule } from '../common-wording';
import { AutoFocusDirective } from './auto-focus.directive';
import { ClassifyValidationErrorPipe } from './classify-validation-error.pipe';
import { FormGroupComponent } from './form-group/form-group.component';
import { InputDirective } from './input.directive';
import { SubmitDirective } from './submit.directive';

@NgModule({
  declarations: [AutoFocusDirective, ClassifyValidationErrorPipe, FormGroupComponent, InputDirective, SubmitDirective],
  imports: [CommonModule, CommonWordingModule, NgxMaskModule.forChild(), TranslocoModule],
  exports: [AutoFocusDirective, ClassifyValidationErrorPipe, FormGroupComponent, InputDirective, SubmitDirective]
})
export class FormsModule {}
